import { useState, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { getCreditReportPdf } from '../features/creditReports/creditReports'
import { showSnackBar } from '../components/Snackbar/Snackbar'

const useViewPdf = () => {
  const dispatch = useDispatch()
  const [pdfUrl, setPdfUrl] = useState(null)
  const [pdfOpen, setPdfOpen] = useState(false)
  const [pdfLoading, setPdfLoading] = useState(false)
  const [loadedReportId, setLoadedReportId] = useState(null)

  useEffect(() => {
    return () => {
      if (pdfUrl) window.URL.revokeObjectURL(pdfUrl)
    }
  }, [pdfUrl])

  const openPdf = useCallback(async (reportId) => {
    // Re-open same report without re-fetching
    if (pdfUrl && loadedReportId === reportId) {
      setPdfOpen(true)
      return
    }
    // Different report — setting pdfUrl to null triggers useEffect cleanup for old URL
    setPdfUrl(null)
    setLoadedReportId(reportId)
    setPdfLoading(true)
    try {
      const result = await dispatch(getCreditReportPdf({ reportId }))
      if (result?.payload?.blobUrl) {
        setPdfUrl(result.payload.blobUrl)
        setPdfOpen(true)
      } else {
        showSnackBar('error', 'PDF not available for this report')
      }
    } catch {
      showSnackBar('error', 'Failed to load PDF')
    } finally {
      setPdfLoading(false)
    }
  }, [dispatch, pdfUrl, loadedReportId])

  const closePdf = useCallback(() => setPdfOpen(false), [])

  const resetPdf = useCallback(() => {
    setPdfOpen(false)
    setPdfUrl(null)
    setLoadedReportId(null)
  }, [])

  return { pdfUrl, pdfOpen, pdfLoading, loadedReportId, openPdf, closePdf, resetPdf }
}

export default useViewPdf
